export const visit = (vm, at) => {
vm(require("pricing-pages-ui/lang/fr.lyaml"));
vm(require("feature-monetization/lang/fr.lyaml"));
vm(require("usage-based-billing-components-lib/lang/CreditEstimator/fr.lyaml"));
vm(require("usage-based-billing-components-lib/lang/fr.lyaml"));
at({ "fr": { "publicPricingPage": { "windowTitles": { "default": "Tarification | HubSpot" } } } });
};